// eslint-disable-next-line import/prefer-default-export
export const CHATGROUPINVITATIONS_SELECTOR_KEY = 'chatgroups/invitations';
export const CHATGROUPINVITATIONS_SELECTOR_KEY_BY_ID = 'chatgroups/invitations/byGroupId';
export const CHATGROUPINVITATIONS_GET_SELECTOR_KEY_BY_ID = 'chatgroups/invitations/get/byGroupId';

export const CHATGROUPINVITATIONS_STATE_ACCEPTED = 'accepted';
export const CHATGROUPINVITATIONS_STATE_CREATED = 'created';
export const CHATGROUPINVITATIONS_STATE_REJECTED = 'rejected';
